module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"alertNotParameters":"There are no present values.\\nTry again from your email."},"es":{"alertNotParameters":"No hay datos existentes.\\nVuelva a intentar desde su correo."}}')
  delete Component.options._Ctor
}
